import { defineMessage } from 'services/localization';

export const messages = {
    myFinalDecisionApproved: defineMessage('approved_by_me'),
    myFinalDecisionRejected: defineMessage('rejected_by_me'),
};
